import { Component } from '@angular/core';
import { PeopleSyncService } from '../services/peoplesync.service';

@Component({
  selector: 'app-admin',
  standalone: false,
  templateUrl: './admin.component.html',
  styleUrl: './admin.component.scss'
})
export class AdminComponent {

  tracking: any;
  errors: any;
  trackingShowCount = 3;
  errorsShowCount = 10;
  showLocalTime = false;
  
  constructor(private peopleSyncService: PeopleSyncService) {
    this.peopleSyncService.getUpdateTracking().subscribe({
      next: (data) => {
        this.tracking = data;
        // sort tracking so most recent by ended_at is first
        this.tracking.sort((a: any, b: any) => {
          return (new Date(b.ended_at).getTime() - new Date(a.ended_at).getTime());
        });
      },
      error: (err) => {
        console.error('Error fetching update tracking:', err);
      }
    });

    this.peopleSyncService.getErrors().subscribe({
      next: (data) => {
        this.errors = data;
        this.errors.sort((a: any, b: any) => {
          return (new Date(b.time).getTime() - new Date(a.time).getTime());
        });
      },
      error: (err) => {
        console.error('Error fetching errors:', err);
      }
    });

  }

  calculateGap(start: any, end: any) {
    let duration = new Date(end).getTime() - new Date(start).getTime();
    var milliseconds = Math.floor((duration % 1000)),
    seconds = Math.floor((duration / 1000) % 60),
    minutes = Math.floor((duration / (1000 * 60)) % 60),
    hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

    return hours + " hours, " + minutes + " minutes, " + seconds + " seconds";
  }

  showMoreTracking(more: number) {
    if (this.tracking.length > more) {
      this.trackingShowCount += more;
    } else {
      this.trackingShowCount = this.tracking.length;
    }
  }

  showMoreErrors(more: number) {
    if (this.errors.length > more) {
      this.errorsShowCount += more;
    } else {
      this.errorsShowCount = this.errors.length;
    }
  }

  toggleTimeMode() {
    this.showLocalTime = !this.showLocalTime;
  }
}
